import { useState } from "react";
import { Form, Input, Checkbox } from "antd";
import { useAppDispatch } from "../../../utils/hooks/redux";
import StyledModal from "../../../components/CustomModal";
import { StyledButton } from "../../../components/styles";
import { updateFoundItemStatus } from "../../../redux/features/foundReport/foundReportAsyncThunk";
import { convertIntoBoardTicket, removeTicketById, updateTicketLocally, updateTicketStatusLocally } from "../../../redux/features/board/columnsSlice";
import { useNavigate } from "react-router-dom";
import SystemPayRoutes from "../../../utils/constants/Routes";
import { FoundItemTypeOptions, FoundStatuses } from "../../../types/FoundItemTypes";
import { ReportType } from "../../../redux/features/board/columnTypes";
import { updateFoundReportStatus } from "../../../redux/features/foundReport/foundReportSlice";


interface RecoverFoundItemWithReasonProps {
    isOpen: boolean;
    onClose: () => void;
    selectedRecord: any;
}

const RecoverFoundItemWithReason = ({ isOpen, onClose, selectedRecord }: RecoverFoundItemWithReasonProps) => {
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const navigate = useNavigate();

    const onFinish = async () => {
        try {
            setLoading(true);
            const values = await form.validateFields();
            const requestPayload = {
                reason: values?.reason,
                id: selectedRecord.id?.toString() ?? "",
                status: FoundStatuses.Open,
                withDeleted: true,
                sendEmail: values?.sendEmail ?? true
            }
            const hasLuggageItemType = FoundItemTypeOptions.FoundLuggage === selectedRecord?.foundType;
            await dispatch(updateFoundItemStatus({ ...requestPayload }));
            await dispatch(updateTicketStatusLocally({ ticket: convertIntoBoardTicket(selectedRecord), sourceStatus: selectedRecord?.status ?? 0, targetStatus: FoundStatuses.Open }));
            await dispatch(updateTicketLocally({ ticket: { ...selectedRecord, isFoundItem: true, foundType: hasLuggageItemType ? FoundItemTypeOptions.FoundLuggage : FoundItemTypeOptions.FoundItem }, type: ReportType.Found }));
            await dispatch(updateFoundReportStatus({ status: FoundStatuses.Open }));
            form.resetFields();
            onClose();
        } catch (error) {
        } finally {
            setLoading(false);
        }
    };


    const handleClose = () => {
        form.resetFields();
        onClose();
    };

    return (
        <StyledModal
            draggable={true}
            footer={
                <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", width: "100%" }}>
                    <StyledButton onClick={handleClose} disabled={loading}>Cancel</StyledButton>
                    <StyledButton type="primary" onClick={() => onFinish()} loading={loading} disabled={loading}>
                        Recover
                    </StyledButton>
                </div>
            }
            open={isOpen}
            onCancel={() => onClose()}
            title="Are you sure you want recover?"
        >
            <Form form={form} onFinish={onFinish} autoComplete="off" layout="vertical" style={{ marginTop: "20px" }}>
                <Form.Item name="reason" label="Recover reason" rules={[{ required: true, message: "Please enter reason" }]}>
                    <Input.TextArea placeholder="Recover reason" name="reason" />
                </Form.Item>
                <Form.Item name="sendEmail" valuePropName="checked" initialValue={true}>
                    <Checkbox>
                        Send email notification
                    </Checkbox>
                </Form.Item>
            </Form>
        </StyledModal>
    );
};

export default RecoverFoundItemWithReason;
